import { useQuery } from '@tcs/common/hooks/useQuery';

interface Props {
  loading: boolean;
  data?: Record<string, unknown>;
}

const useAccountApplication = (applicationId?: string): Props => {
  const { data, isLoading: loading } = useQuery<Record<string, unknown>, Error>(
    `/accounts/applications/${applicationId}`,
    {
      enabled: !!applicationId,
    },
  );

  return {
    loading,
    data,
  };
};

export default useAccountApplication;
